(function($) {

	// Temporary Achievement Banner Dropdown functionality
	$.fn.mobileAchievements = function( options ) {

		options = $.extend({}, {
			menuButtonSelector: '.profile--banner',
			menuButtonActiveClass: 'active',
			menuPane: '.achievement-banner'
		}, options);

		var bannerOpen = false,
				$menuButton = $( options.menuButtonSelector ),
				$menuPane = $( options.menuPane );

		var closePane = function() {
			$menuButton.removeClass( options.menuButtonActiveClass );
			$menuPane.slideUp();
			bannerOpen = false;
		};

		var menuBtnFn = function() {

			$menuButton.bind( 'touchstart, click', function(event) {

				event.stopPropagation();
				event.preventDefault();

				if ( bannerOpen ) {
					closePane();
				}
				else{
					$(this).addClass( options.menuButtonActiveClass );
					$menuPane.slideDown();
					bannerOpen = true;
				}
			}); //end button bind
		}; //end menuBtnFn

		var achievementDropper = function() {
			$('.status--block .status--menu-dropper').each(function(){
				$(this).bind('touchstart, click', function(event) {

					event.stopPropagation();
					event.preventDefault();

					if ( bannerOpen && !$(this).next().is(':visible') && $(this).next().length > 0) {
						//close what's already open
						$(this).removeClass('toggle');
						$(this).next().slideUp(250);

						//expand current click
						$(this).addClass('toggle');
						$(this).next().slideDown(250);
					}
					else if ( bannerOpen && $(this).next().is(':visible') ) {
						//close this item
						$(this).removeClass('toggle');
						$(this).next().slideUp(250);
					}
				}); //end bind
			});
		};//end achievementDropper


		menuBtnFn();
		achievementDropper();


		$(window).resize(function(){
			if( !$('#achievement-trigger').is(':visible') ) {
				$menuButton.unbind( 'touchstart, click');
				$('.status--block .status--menu').removeAttr('style');
			} else {
				$menuButton.unbind( 'touchstart, click');
				menuBtnFn();
			}
		});

		return this;
	};
})(jQuery);
